import type { SVGProps } from 'react'
const SvgSyPaperNegative = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M8.084 2.012C5.619 2.012 3.5 4 3.5 6.49v10.85c0 2.557 2.04 4.525 4.584 4.525h7.988c2.477 0 4.48-2.06 4.48-4.525V8.037a.75.75 0 0 0-.208-.52l-5.067-5.275a.75.75 0 0 0-.54-.23zm0 1.5h6.332l4.637 4.828v9c0 1.655-1.337 3.025-2.98 3.025h-7.99C6.275 20.365 5 19.135 5 17.34V6.49c0-1.63 1.43-2.978 3.084-2.978"
				clipRule="evenodd"
			/>
			<path d="M14.475 2a.75.75 0 0 0-.75.75v2.91a3.335 3.335 0 0 0 3.316 3.324l1.838.002h.637c.161 0 .184.004.33-.006a.75.75 0 0 0 .699-.796.75.75 0 0 0-.797-.7c.1-.006-.08.002-.238.002h-.631c-.512 0-1.176 0-1.834-.002a1.81 1.81 0 0 1-1.82-1.824V2.75a.75.75 0 0 0-.75-.75" />
			<path
				d="M9.393 12.998a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h4.902a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyPaperNegative
